// src/components/courses/CourseCard.js
//
// REESCRITO — ya no depende de ../../data/courses (estático) ni lee
// enrolledCourses del progressStore internamente. Ahora recibe el
// curso ya en el shape real de cursoService (CursoListDto mapeado) y,
// opcionalmente, el estado de inscripción/progreso como props — así
// el padre decide cómo obtenerlos (catálogo público vs "mis cursos").

import React from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Chip,
  Avatar,
  LinearProgress,
} from '@mui/material';
import { MenuBook, Groups, Public } from '@mui/icons-material';

const NIVEL_LABELS = { Basico: 'Básico', Intermedio: 'Intermedio', Avanzado: 'Avanzado' };
const NIVEL_COLORS = { Basico: '#00d9a5', Intermedio: '#ffc947', Avanzado: '#e94560' };

function CourseCard({ course, isEnrolled = false, progress = 0, showProgress = false }) {
  return (
    <Card
      component={Link}
      to={`/course/${course.slug}`}
      sx={{
        textDecoration: 'none',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 8px 30px rgba(0,0,0,0.3)',
        },
      }}
    >
      {/* Thumbnail */}
      <Box sx={{ position: 'relative' }}>
        <CardMedia
          component="img"
          height="180"
          image={course.image || 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800'}
          alt={course.title}
          sx={{ objectFit: 'cover' }}
        />

        {/* Nivel */}
        <Chip
          label={NIVEL_LABELS[course.level] || course.level}
          size="small"
          sx={{
            position: 'absolute', top: 12, left: 12,
            bgcolor: NIVEL_COLORS[course.level] || 'primary.main',
            color: 'black', fontWeight: 600,
          }}
        />

        {/* Curso global de la red */}
        {course.isGlobal && (
          <Chip
            icon={<Public sx={{ fontSize: 16, color: 'white !important' }} />}
            label="Red Solidaria"
            size="small"
            sx={{ position: 'absolute', top: 12, right: 12, bgcolor: 'info.main', color: 'white', fontWeight: 600 }}
          />
        )}

        {/* Progreso */}
        {isEnrolled && showProgress && (
          <Box
            sx={{
              position: 'absolute', bottom: 0, left: 0, right: 0, p: 1.5,
              background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
              <Typography variant="caption" color="rgba(255,255,255,0.8)">Progreso</Typography>
              <Typography variant="caption" color="success.main" fontWeight={600}>{Math.round(progress)}%</Typography>
            </Box>
            <LinearProgress variant="determinate" value={progress} color="success" sx={{ height: 4, borderRadius: 2 }} />
          </Box>
        )}
      </Box>

      {/* Content */}
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{
            mb: 1, overflow: 'hidden', textOverflow: 'ellipsis',
            display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
          }}
        >
          {course.title}
        </Typography>

        {course.subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }} noWrap>
            {course.subtitle}
          </Typography>
        )}

        {/* Meta info */}
        <Box sx={{ display: 'flex', gap: 2, mb: 1.5, color: 'text.secondary' }}>
          {course.category && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <MenuBook fontSize="small" />
              <Typography variant="body2">{course.category}</Typography>
            </Box>
          )}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Groups fontSize="small" />
            <Typography variant="body2">{course.totalEnrollments || 0} estudiantes</Typography>
          </Box>
        </Box>

        {/* Instructor */}
        {course.instructor && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
            <Avatar sx={{ width: 28, height: 28 }}>{course.instructor[0]}</Avatar>
            <Typography variant="body2" color="text.secondary">{course.instructor}</Typography>
          </Box>
        )}

        {/* Footer */}
        <Box
          sx={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            mt: 'auto', pt: 1.5, borderTop: 1, borderColor: 'divider',
          }}
        >
          <Typography variant="caption" color="text.secondary">
            {course.institution || 'Curso de la red'}
          </Typography>
          {isEnrolled && <Chip label="Inscrito" size="small" color="success" />}
        </Box>
      </CardContent>
    </Card>
  );
}

export default CourseCard;
